import * as angular from 'angular';
import * as _ from 'underscore';
import { Dictionary } from 'underscore';
import { IPagination } from '../../../../../app.common/modules/common/models';
import { IBrandStatuses, IBrandHtmlTooltip, IBrandAnchor, IBrand } from '../../brands.service';

interface IResolveChoiceBrand {
    brandStatus: IBrandStatuses;
    htmlTooltip: IBrandHtmlTooltip;
    startAnchor: IBrandAnchor;
    anchorNoChar: string;
    anchors: IBrandAnchor[];
    brands: {};
    singleSelect: boolean;
}

class ChoiceBrandsComponent {
    modalInstance: ng.ui.bootstrap.IModalServiceInstance = <any>this;
    resolve: IResolveChoiceBrand;
    brandsform: ng.IFormController;
    waiting: false;
    brandsFiltered = {};
    isPristineData = true;
    countSelected: Dictionary<number> = {
        pending: 0,
        approved: 0
    };
    settings: IPagination;

    private pageSize = 52;
    private initialSelectedBrands: IBrand[];

    $onInit() {
        this.brandsFiltered[this.resolve.startAnchor.value] = _.sortBy(this.resolve.brands[this.resolve.startAnchor.value], (item: IBrand) => {
            return item.Name.toLowerCase();
        });
        this.initialSelectedBrands = this.getSelectedBrands();
        this.updateCountSelectedBrands(this.initialSelectedBrands);
        this.settings = {
            total: this.brandsFiltered[this.resolve.startAnchor.value].length,
            pageSize: this.pageSize,
            page: 1
        };
    }

    add() {
        this.modalInstance.close({ $value: this.getSelectedBrands() });
    }

    discard() {
        this.modalInstance.dismiss({ $value: 'cancel' });
    }

    goToAnchorBrand = (anchor: IBrandAnchor) => {
        if (anchor.disabled) { return; }
        _.forEach(this.resolve.anchors, (item) => {
            item.selected = false;
        });
        anchor.selected = true;
        this.brandsFiltered = {};
        this.brandsFiltered[anchor.value] = _.sortBy(this.resolve.brands[anchor.value], (item: IBrand) => {
            return item.Name.toLowerCase();
        });
        this.settings = {
            total: this.brandsFiltered[anchor.value].length,
            pageSize: this.pageSize,
            page: 1
        };
    }

    changeState = (brand: IBrand) => {
        var selectedBrands = [];

        if (brand.selected && this.resolve.singleSelect) {
            this.unSelectBrands(brand);
            selectedBrands = [brand];
        } else {
            selectedBrands = this.getSelectedBrands();
        }

        this.updateCountSelectedBrands(selectedBrands);
        this.isPristineData = selectedBrands.length === this.initialSelectedBrands.length;

        if (this.isPristineData) {
            this.isPristineData = _.all(selectedBrands, (selected) => {
                return _.contains(this.initialSelectedBrands, selected);
            });
        }
    }

    private getSelectedBrands() {
        let selectedBrands: IBrand[] = [];
        _.forEach(<[IBrand[]]>_.values(this.resolve.brands), (brands) => {
            selectedBrands = _.union(selectedBrands, _.where(brands, { 'selected': true }));
        });
        return selectedBrands;
    }


    private unSelectBrands(brand: IBrand) {
        _.forEach(<[IBrand[]]>_.values(this.resolve.brands), (brands) => {
            _.forEach(brands, (item) => {
                item.selected = item.ID === brand.ID;
            });
        });
    }

    private updateCountSelectedBrands(selectedBrands: IBrand[]) {
        if (_.isArray(selectedBrands)) {
            this.countSelected = _.countBy(selectedBrands, (brand) => {
                return brand.Status === this.resolve.brandStatus.approved ? 'approved' : 'pending';
            });
        }
    }

    private popupBrandsHeight() {
        $('.containerBrandList').css('height', ($(window).height() - $('.containerAlphabet ').height() - 117) + 'px');
    }
}

angular.module('naut').component('choiceBrands', {
    template: require('./choiceBrands.html'),
    controller: ChoiceBrandsComponent,
    controllerAs: '$ctrl',
    bindings: {
        resolve: '<',
        close: '&',
        dismiss: '&'
    }
});



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer/modules/brands/components/choiceBrands/choiceBrands.component.ts